// Tigger Group Main Tab (2700489754)
/*
ashraf 9/22/2022 2699758070 event tactics sidebar changes
Sohel 10/10/2022 2699758070 Removed unused Code.
Sohel 10/14/2022 2700430604 Trigger Group ->Added Comments
Ashraf  10/28/2022  2700430604 moved main tabs to header

*/
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TriggerSubTabs from './SubTabs';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function EventTacticTabs({value}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 && (
          <TriggerSubTabs/>
        )}
      </div>
    </div>
  );
}
